import { money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const gqlQuery = gql`
  query TransactionR2($id: ID!) {
    transactionR2(id: $id) {
      __typename
      id
      category {
        name
      }
      createdAt
      description
      detailsR2 {
        title
        items {
          __typename
          key
          title
          value
          description
          ... on IDetailCopyItem {
            copy
          }
          ... on TransactionDetailV2VAccountItem {
            copy
          }
          ... on TransactionDetailV2VCustomerItem {
            copy
          }
          ... on TransactionDetailV2AAccountItem {
            copy
          }
          ... on TransactionDetailV2ACustomerItem {
            transferId
            description
            value
            copy
            recipientContactInfo
          }
          ... on TransactionDetailRdcCheckImagesItem {
            rdcId
            checkImages {
              title
              url
            }
          }
        }
      }
      direction
      status
      caption
      type
      value {
        ...money
      }
      ... on V2ATransaction {
        id
        isCancellable
        transferId
      }
      ... on AtmTransaction {
        disputeEligibility {
          isEligible
        }
        disputeInfo {
          id
          disputeStatus
          disputeCategory
          claimId
        }
      }
      ... on DebitCardTransaction {
        disputeEligibility {
          isEligible
        }
        disputeInfo {
          id
          claimId
          disputeStatus
          disputeCategory
        }
        payOverTime {
          status
          loanId
        }
      }
      ... on RdcTransaction {
        rdcId
        status
        createdAt
        confirmationNumber
        accountLink {
          name
          nickname
          accountNumberLast4
          product
        }
        checkImages {
          title
          url
        }
        checkImageUrls
        disclaimer
      }
      ... on ChargeCardTransaction {
        merchant {
          name
        }
      }
    }
  }
  ${money}
`;

export default gqlQuery;
